import { Decoration } from '@tiptap/pm/view';
import { NODE_SEARCH_TARGETS } from './node-search-targets';
import type { SearchResult } from './search';

const TEXT_SEARCH_RESULT_CLASS = 'text-search-result';
const NODE_SEARCH_RESULT_CLASS = 'node-search-result';
const MATH_SEARCH_RESULT_CLASS = 'math-search-result';
const IMAGE_SEARCH_RESULT_CLASS = 'image-search-result';

function searchResultIndexClass(baseClass: string, index: number) {
    return `${baseClass}-index-${index}`;
}

export function getDecorations(results: SearchResult[], resultIndex: number): Decoration[] {
    const decorations: Decoration[] = [];

    results.forEach((result, index) => {
        const isCurrent = index === resultIndex;
        const indexClass = searchResultIndexClass(NODE_SEARCH_RESULT_CLASS, index);
        let decoration: Decoration;

        if (result.nodeType === 'text') {
            decoration = Decoration.inline(result.from, result.to, {
                class: [
                    TEXT_SEARCH_RESULT_CLASS,
                    searchResultIndexClass(TEXT_SEARCH_RESULT_CLASS, index),
                    isCurrent ? `${TEXT_SEARCH_RESULT_CLASS}-current` : '',
                ]
                    .filter(Boolean)
                    .join(' '),
            });
        } else if (result.nodeType.toLowerCase().includes('math')) {
            decoration = Decoration.node(result.from, result.to, {
                class: [MATH_SEARCH_RESULT_CLASS, indexClass, isCurrent ? `${MATH_SEARCH_RESULT_CLASS}-current` : '']
                    .filter(Boolean)
                    .join(' '),
            });
        } else if (result.nodeType.toLowerCase().includes('image')) {
            decoration = Decoration.node(result.from, result.to, {
                class: [IMAGE_SEARCH_RESULT_CLASS, indexClass, isCurrent ? `${IMAGE_SEARCH_RESULT_CLASS}-current` : '']
                    .filter(Boolean)
                    .join(' '),
            });
        } else if (result.matchedAttr && !NODE_SEARCH_TARGETS.get(result.nodeType)?.highlightEntireNode) {
            const fieldClass = `${NODE_SEARCH_RESULT_CLASS}-field-${result.matchedAttr}`;
            decoration = Decoration.node(result.from, result.to, {
                class: [fieldClass, indexClass, isCurrent ? `${fieldClass}-current` : ''].filter(Boolean).join(' '),
            });
        } else {
            decoration = Decoration.node(result.from, result.to, {
                class: [NODE_SEARCH_RESULT_CLASS, indexClass, isCurrent ? `${NODE_SEARCH_RESULT_CLASS}-current` : '']
                    .filter(Boolean)
                    .join(' '),
            });
        }

        if (decoration) decorations.push(decoration);
    });

    return decorations;
}
